const CardTitle = ({ text = "", description = "" }) => {
  return (
    <div className="flex flex-col gap-0.5">
      <h3 className="text-[12.5px] font-bold text-gray-800 dark:text-gray-100">{text}</h3>
      <p className="text-xs text-gray-500 dark:text-gray-400">{description}</p>
    </div>
  );
};

export default CardTitle;
